import { render, staticRenderFns } from "./FullSupplyChain.vue?vue&type=template&id=b1940c1a&scoped=true"
import script from "./FullSupplyChain.vue?vue&type=script&lang=js"
export * from "./FullSupplyChain.vue?vue&type=script&lang=js"
import style0 from "./FullSupplyChain.vue?vue&type=style&index=0&id=b1940c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1940c1a",
  null
  
)

export default component.exports